import { render, staticRenderFns } from "./VersionEdit.vue?vue&type=template&id=b8273540"
import script from "./VersionEdit.vue?vue&type=script&lang=js"
export * from "./VersionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports